import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f209f9f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "middleware-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middleware-background" }, null, -1))
const _hoisted_3 = { class: "middleware" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round icon" }, "schedule", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Handle = _resolveComponent("Handle")!
  const _component_flow_node_wrapper = _resolveComponent("flow-node-wrapper")!

  return (_openBlock(), _createBlock(_component_flow_node_wrapper, {
    name: _ctx.data.name
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Handle, {
            class: _normalizeClass(["handle target-handle", { active: _ctx.data.showHandle }]),
            type: "target",
            position: "left"
          }, null, 8, ["class"]),
          _createElementVNode("div", {
            class: _normalizeClass(["target-handle-dot", { active: _ctx.data.showHandle }])
          }, null, 2),
          _createVNode(_component_Handle, {
            class: "handle source-handle",
            type: "source",
            position: "left"
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["name"]))
}